import * as PIXI from 'pixi.js';
import * as TweenJS from "slotworks/utils/tween";
import { CenterPivot, PIXIElement } from 'slotworks/graphics/pixi/group';
import { parallel, sequence } from 'slotworks/utils/race-utils';
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import { FadeIn, FadeOut, ZoomIn, ZoomOut } from "slotworks/graphics/animation/base-animations";
import gameState from "slotworks/model/game-state";
import RainbowStacksRespinRecord from "integration/revolver/schema/respin-record";
import getJackpotTypeFromSymbol from "util/jackpot";
import translations from 'slotworks/i18n/translations';
import { Emitter } from 'pixi-particles';
import { AbstractSceneTransition } from 'slotworks/graphics/layers/scene-transitions/abstract-scene-transition';
import { GlowTransitionCommand } from 'commands/glow-transition-command';
import Timer from 'slotworks/utils/timer';
import deviceInfo from 'slotworks/utils/device-info';
import soundManager from 'slotworks/sound/sound-manager';

export default class RespinIntroTransitions extends AbstractSceneTransition {


    private background: PIXI.Sprite;

    private glitter: Emitter;

    private container: PIXI.Container;
    private tween: TweenJS.Tween;

    public in(): Contract<void> {

        const record = gameState.getCurrentGame().getCurrentRecord() as RainbowStacksRespinRecord;
        const jackpotType = getJackpotTypeFromSymbol(record);
        this.hide(jackpotType);

        const headline = Layers.Prompts.getText("headline_text");
        const content = Layers.Prompts.getText("content_text");
        const fs = gameState.getCurrentGame().inFreespinsGame ? "fs" : "";
        headline.text = translations.get(`respins${fs}_intro_${jackpotType}_a`)
        content.text = translations.get(`respins${fs}_intro_${jackpotType}_b`)

        const leprechaun = Layers.Prompts.getSprite("Leprechaun");
        const leprechaunPosition = Layers.Prompts.getPosition(`${jackpotType}_Leprechaun_SpineAnim_pos`);
        leprechaun.position.set(leprechaunPosition.x, leprechaunPosition.y);

        const backgound = Layers.CelebrationBackground.getSprite("fullscreen");
        FadeIn(backgound, 200).execute();

        this.background = Layers.Prompts.container.children[0] as PIXI.Sprite;

        this.container = CenterPivot([...(Layers.Prompts.container.children as PIXIElement[])], "prompt_tmp");

        return sequence([
            () => this.zoomIn(this.container, 400),
            () => Contract.wrap(() => {
                if(!deviceInfo.isDesktop) {
                    deviceInfo.onLayoutChange.add(this.onLayoutChange);
                }
            })
        ]);
    }

    public out(): Contract<void> {
        soundManager.customEvent("jp_transition");
        const backgound = Layers.CelebrationBackground.getSprite("fullscreen");
        Timer.setTimeout(() => GlowTransitionCommand().execute(), 150);
        if(!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.remove(this.onLayoutChange);
        }
        return parallel([
            () => this.zoomOut(this.container, 400),
            () => FadeOut(backgound, 300)
        ]);
    }

    public destroy() {
        super.destroy();
    }

    private onLayoutChange = () => {
        setTimeout(() => {
            const position = Layers.Prompts.getPosition("prompt");
            this.container.position.set(position.x + position.width/2, position.y + position.height/2);
            const difference = position.width / this.background.width;
            this.container.scale.set(difference, difference);
        }, 1);
    }

    private zoomIn(container: PIXI.Container, time: number):Contract<void> {
        return new Contract(resolve => {
            this.container.scale.set(0, 0);
            new TweenJS.Tween(container.scale)
            .to({x: 1, y: 1}, time)
            .easing(TweenJS.Easing.Back.Out)
            .onComplete(resolve)
            .start();
        });
    }

    private zoomOut(container: PIXI.Container, time: number):Contract<void> {
        return new Contract(resolve => {
            new TweenJS.Tween(container.scale)
            .to({x: 0, y: 0}, time)
            .easing(TweenJS.Easing.Back.In)
            .onComplete(resolve)
            .start();
        });
    }

    private hide(jackpotType: string) {
        for (let pot of POTS) {
            if (pot != jackpotType) {
                Layers.Prompts.getSprite(pot + "_pot").visible = false;

                const title = Layers.Prompts.getSprite(pot.toUpperCase());
                if (title)
                    title.visible = false;
            }
        }
    }
}

const POTS = ["grand", "major", "maxi", "mini"];


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/respins-intro-transitions.ts